// Coincide con el slugify del backend (platforms/api/src/utils/helpers.ts) —
// misma normalizacion, para que el slug que se muestra en el formulario sea
// el mismo que terminara persistido.
export function slugify(value: string): string {
  return value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '')
}
